import { toast } from 'sonner';

/**
 * The console's one toast surface (build/10 §6).
 *
 * Every mutation resolves to a toast through here — no `alert()`, no bespoke
 * banners, no direct `sonner` imports in screens. Centralising it is what makes
 * "every mutation gives feedback" checkable, and gives one place to add the
 * traceId to failure toasts once the API client is returning error envelopes.
 */
export const notify = {
  success(message: string, description?: string) {
    toast.success(message, { description });
  },
  error(message: string, description?: string) {
    toast.error(message, { description });
  },
  info(message: string, description?: string) {
    toast(message, { description });
  },
};
